import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookCoverStyleResponse } from '../../responses/platform/book-cover-style.response';
import { BookCoverStyleRequest } from '../../requests/platform/book-cover-style.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class BookCoverStyleService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public GetAll(idBookVersion: number): Observable<BookCoverStyleResponse> {
    return this.http
      .get<BookCoverStyleResponse>(
        environment.urlApiPlatform + 'BookCoverStyle/idBookVersion/' + idBookVersion,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

    public SetCoverStyle(request: BookCoverStyleRequest): Observable<ReturnStruct> {
    return this.http
      .post<ReturnStruct>(
        environment.urlApiPlatform + 'BookCoverStyle',
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}